import React from "react";
import GuidesIcon from "../../../assets/img/guides-icon.png";


const renderAdditionalInformation = () => {
    return (<div
        className="w-[510px] px-2 py-4 text-[14px] flex flex-col gap-[2px] text-main-normal z-50">
        <div className="h-[19px] flex flex-row gap-2">
            <span>•</span>
            <span>We currently support exports from Microsoft guides (example.guide).</span>
            <span><img src={GuidesIcon} className="h-[20px]"/></span>
        </div>

        <div className="h-[19px] flex items-center gap-2">
            <span>•</span>
            <span>A maximum of fifty files at a time.</span>
        </div>

        <div className="h-[19px] flex items-center gap-2">
            <span>•</span>
            <span>Check out:</span>
            <span className="cursor-pointer text-link-normal">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://helpdesk.frontline.io/portal/en/kb/articles/importing-microsoft-dynamics-guides-to-frontline-flows#Introduction"
                >How to convert Guides to flow.</a>
            </span>
        </div>

    </div>)
}

export {renderAdditionalInformation}